import { Component, inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { ServiceUploadCertificateModalStore } from './service-upload-certificate-modal.store';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import {
    ServiceUploadCertificateComponent,
} from '../service-upload-certificate/service-upload-certificate.component';

@Component({
    selector: 'app-service-upload-certificate-modal',
    imports: [
        ServiceUploadCertificateComponent,
    ],
    templateUrl: './service-upload-certificate-modal.component.html',
    styleUrl: './service-upload-certificate-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [ServiceUploadCertificateModalStore]
})
export class ServiceUploadCertificateModalComponent extends BaseDialogComponent {
    public readonly store = inject(ServiceUploadCertificateModalStore);

    @ViewChild(ServiceUploadCertificateComponent) serviceUploadCertificateComponent!: ServiceUploadCertificateComponent;

    protected readonly serviceId = this.dialogConfig.data.serviceId;

    override async save() {
        const res = await this.serviceUploadCertificateComponent.save();

        if (!res) {
            return;
        }
        contentGlobalSuccess.next('common.created');
        this.dialogRef.close(true);
    }
}
